// extracted by mini-css-extract-plugin
export default {"page":"HG","headerblock":"IG","text":"JG","toptext":"KG","ingredientswrapper":"LG","buttonwrapper":"MG"};
    if(module.hot) {
      // 1726593106324
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  